export interface ISearchLocaleValues {
    placeholder:string;
    noResults:{
        header:string;
        message:string;
    };
}
